import React, { useEffect, useRef, useCallback, useMemo, useState, forwardRef } from 'react';

import AntLocalization from '../../../utils/AntLocalization.js';
import AntAuth from '../../../utils/AntAuth.js';
import AntAPI from '../../../utils/AntAPI.js';
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import Button from 'devextreme-react/button';
import { FaStore } from 'react-icons/fa';
import { FaLocationDot } from 'react-icons/fa6';

import './index.scss';


export default function (props, ref) {
    const [stores, setStores] = useState([]);
    const [currentStoreName, setCurrentStoreName] = useState('');
    const isQueried = useRef(false);

    const API = useMemo(() => new AntAPI('user', 'ACUserAuthen', []));

    const onStoreClick = useCallback(async (e) => {
        AntAuth.switchStore(e.itemData?.store_code, () => {
            setCurrentStoreName(e.itemData?.text);
        });
    }, []);

    const initStores = useCallback(async () => {
        let strURL = API.routeURL + '/switchableStores';

        let result = await API.getList({}, strURL);
        if (result && result.rows instanceof Array && result.rows !== null) {
            let ar = [
                // {
                //     store_code: 'ALL_STORES',
                //     store_name: 'ALL_STORES',
                //     text: AntLocalization.translateText({ vi: 'Tất cả cửa hàng', en: 'All Stores', fr: 'Tous les magasins', es: 'Todas las tiendas', id: 'Semua toko', ja: '全店舗', zh: '所有门店', ko: '모든 매장', hi: 'सभी स्टोर', ar: 'جميع المتاجر' }),
                //     onClick: onStoreClick
                // }
            ];
            ar.push(
                ...result.rows.map((r) => {
                    return {
                        store_code: r.code,
                        store_name: r.name,
                        text: r.name,
                        onClick: onStoreClick
                    };
                })
            );

            isQueried.current = true;
            setStores(ar);
        }
    }, [onStoreClick]);

    useEffect(() => {
        initStores();
    }, []);

    useEffect(() => {
        let storeCode = AntAuth.getSessionInfo('store_code');
        let found = stores.find((s) => s.store_code === storeCode);
        if (isQueried.current) setCurrentStoreName(found ? found.text : AntLocalization.translateText({ vi: 'Tất cả cửa hàng', en: 'All Stores', fr: 'Tous les magasins', es: 'Todas las tiendas', id: 'Semua Toko', ja: '全店舗', zh: '所有门店', ko: '전체 매장', hi: 'सभी स्टोर', ar: 'جميع المتاجر' }));
    }, [stores]);

    return (
        currentStoreName &&
        isQueried.current &&
        stores.length > 1 && (
            <Button id={'switchStore'} className={'ant-pos-home-current-store-button'} width={'auto'} height={'100%'} stylingMode={'text'}>
                <div className={'ant-pos-home-switchstore-panel'}>
                    <div className={'ant-pos-home-current-store'}>
                        <FaLocationDot className={'ant-pos-home-current-store-image'} />
                        <div className={'ant-pos-home-current-store-name'}>{currentStoreName}</div>
                    </div>
                    <ContextMenu
                        items={stores}
                        target={'.ant-pos-home-current-store-button'}
                        showEvent={'dxclick'}
                        cssClass={'ant-pos-home-stores-menu'}
                    >
                        <Position my={'left top'} at={'left bottom'} target={window} />
                    </ContextMenu>
                </div>
            </Button>
        )
    );
}
